import WalletAddressList from "./WalletAddressList";
import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import Sidebar from "./Sidebar";
import { useIntl } from "react-intl";
import { SharedContextProps } from "@lib/types";
import { ROUTES } from "@lib/constants";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useParamsManager } from "@lib/hooks/useParamsManager";
import { apiGetAIWallets } from "@lib/api/walletAI";

const SharedWalletAddressAIList: React.FC<SharedContextProps> = ({
  context,
  detailContext,
  customerId,
  customTitle,
  withoutContainer = false,
  withoutBreadcrumb,
  withoutSidebar = false,
  pageIsActive = true,
}) => {
  const { messages } = useIntl();
  const { walletId } = useParams();
  const _withoutSidebar = withoutSidebar || withoutContainer || !pageIsActive;

  const filter = [].concat(
    ...(customerId ? [`customerId||$eq||${customerId}`] : []),
  );

  const { params } = useParamsManager({
    page: 1,
    limit: 100,
    sort: "createdAt,DESC",
    filter: filter,
    join: ["customer"],
    isShowParamsInUrl: false,
  });

  const aiWalletsQuery = useQuery({
    queryFn: () => apiGetAIWallets(params),
    queryKey: ["ai-wallets", JSON.stringify(params)],
    enabled: !!params && !!pageIsActive && !_withoutSidebar,
  });
  const { data } = aiWalletsQuery;
  const apiData = data?.data?.data;

  const walletIdProp = useMemo(() => {
    const find = apiData?.find((w) => w.id === walletId);
    return find?.name || "";
  }, [walletId, apiData]);

  // Context-specific title and breadcrumb
  const title = customTitle || (messages["common.aiWalletAccounts"] as string);

  return (
    <AppsContainer
      noContainer={!!withoutContainer}
      title={title}
      breadcrumbProps={{
        urlParams: {
          [ROUTES.URL_PARAMS.WALLET_ID]: walletIdProp,
        },
      }}
      cardProps={{
        borderFull: true,
        coloredHeader: true,
      }}
      showBreadcrumb={!withoutBreadcrumb}
      sidebarContent={
        !withoutSidebar ? (
          <AppsContainer.SidebarCard>
            <Sidebar
              aiWalletsQuery={aiWalletsQuery}
              context={context}
              customerId={customerId}
            />
          </AppsContainer.SidebarCard>
        ) : null
      }
    >
      <WalletAddressList
        aiWalletsQuery={aiWalletsQuery}
        context={context}
        detailContext={detailContext}
        customerId={customerId}
        pageIsActive={pageIsActive}
      />
    </AppsContainer>
  );
};

export default SharedWalletAddressAIList;
